import { Component } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import "../Styles/style.css";
import VerifiedIcon from "@mui/icons-material/Verified";
import List from "@mui/material/List";
import { Link } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Modal from "@mui/material/Modal";
import {
  Alert,
  Avatar,
  Card,
  CardContent,
  CircularProgress,
  InputAdornment,
  Snackbar,
  Typography,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { BASE_URL } from "../components/config/config";
import CenterRegistrationApi from "../components/centerRegistration/Api/api";
import CenterComponentApi from "../components/centerComponent/api/api";
import { IndianStates } from "../assets/IndianStates";
import axios from "axios";
import CopyButton from "../components/ServicesStatus/ClipbaordButton";
import RazorPayment from "./RazorPayPayment";
import DesktopBanner from "../assets/desktop_banner.png";
import MobileBanner from "../assets/mobile_banner.png";

// Modal css
const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid gray",
  boxShadow: 44,
  p: 4,
  borderRadius: 4,
  color: "black",
};

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
    minWidth: "300px",
    "@media (max-width: 768px)": {
      minWidth: "250px",
    },
    "@media (max-width: 480px)": {
      minWidth: "100%",
    },
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
  headerImageWrapper: {
    width: "100%",
    height: "auto",
  },
  headerImage: {
    width: "100%",
    height: "auto",
    display: "block",
    objectFit: "cover",
    maxHeight: "400px",
  },
  desktopImage: {
    display: "block",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  mobileImage: {
    display: "none",
    "@media (max-width: 768px)": {
      display: "block",
    },
  },
};

const AVAILABLE_TIME_PREFERENCES = [
  "IMMEDIATELY",
  "WITHIN_24_HOURS",
  "SPECIFIC_DATE_AND_TIME",
];

const TIME_PREFERENCE_LABELS = {
  IMMEDIATELY: "Immediately",
  WITHIN_24_HOURS: "Within 24 Hours",
  SPECIFIC_DATE_AND_TIME: "Specific Date & Time",
};

class PublicTicketBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceRequired: "",
      specificRequirement: "",
      name: "",
      phoneNumber: "",
      alternatePhoneNumber: "",
      houseNumber: "",
      locality: "",
      pincode: "",
      city: "",
      state: "",
      country: "INDIA",
      timePreference: "",
      offerCode: "ONIT2026",
      specific_date_time: new Date(),

      toast: {
        open: false,
        msg: "",
        duration: 10000,
        type: "",
      },
      isFormValid: false,
      servicesList: [],
      TicketModalOpen: false,
      ticketModalData: [],
      isRegistering: false,
      tickectId: "",
      verifyOtp: false,
      otp: "",
      paymentStatus: "",
      needToPay: false,
      razorpayinitiate: false,
      isMobile: false,
      isFetchingPincode: false,
    };
  }

  getAllServicesExists() {
    new CenterRegistrationApi()
      .getAllActiveServices()
      .then((res) => {
        this.setState({
          servicesList: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  onChangeSpecificDateAndTime(newValue) {
    this.setState({ specific_date_time: newValue });
  }

  showDialog = (open, type, msg) => {
    this.setState({
      toast: {
        open: open,
        msg: msg,
        duration: 10000,
        type: type,
      },
    });
  };

  closeDialog = (open = false) => {
    this.setState({
      toast: {
        open: open,
        msg: "",
        duration: 5000,
        type: "",
      },
    });
  };

  handleChange = (e) => {
    let { name, value } = e.target;

    if (name == "pincode") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length <= 6) {
        this.setState({
          pincode: digitsOnly,
        });
      }

      return;
    }
    if (name === "phoneNumber" || name === "alternatePhoneNumber") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length <= 10) {
        this.setState({
          [name]: digitsOnly,
        });
      }
      return;
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        console.log(this.state);
      }
    );
  };

  handleCreateTickect = async (ress) => {
    const {
      serviceRequired,
      specificRequirement,
      name,
      phoneNumber,
      alternatePhoneNumber,
      houseNumber,
      locality,
      city,
      state,
      country,
      pincode,
      timePreference,
      offerCode,
    } = this.state;
    if (
      !(
        serviceRequired &&
        name &&
        phoneNumber &&
        houseNumber &&
        pincode &&
        timePreference &&
        offerCode &&
        state &&
        city
      )
    ) {
      this.setState({
        isFormValid: true,
      });

      this.showDialog(true, "error", "Please fill in all required details");
      return;
    }

    this.setState({
      isRegistering: true,
    });

    if (this.state.timePreference == "SPECIFIC_DATE_AND_TIME") {
      if (!this.state.specific_date_time) {
        this.showDialog(true, "error", "Please fill in Specific date and time");
        return;
      }
    }

    let payload = {
      service_provided_for: serviceRequired,
      specific_requirement: specificRequirement,
      personal_details: {
        primary_phone: {
          country_code: "+91",
          mobile_number: phoneNumber,
        },
        alternate_phone: {
          country_code: "+91",
          mobile_number: alternatePhoneNumber,
        },
        name: name,
      },
      time_preference: {
        time_preference_type: timePreference,
      },
      offers_applied: {
        offer_code: offerCode,
      },
      address_details: {
        house_number: houseNumber,
        locality: locality,
        city: city,
        state: state,
        pincode: pincode,
        country: country,
      },
      // center_obj_id: "64f50a500c2e9bbc94ed1b39",
      urldata: window.location.href,
      // urldata: "https://app.onit.services/#/booking/INA2021",
    };

    await new CenterComponentApi()
      .PublicTicketBookingWithoutINA(payload)
      .then(async (res) => {
        if (res?.message === "Please complete the payment process") {
          this.handleInitiatePayment();
          this.setState({ tickectId: res?.data?._id });
        } else {
          const ticketData = res?.data?.resData || res?.data || res;
          this.setState({ ticketModalData: ticketData });
          alert("Your request created successfully");
          this.setState({ TicketModalOpen: true });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isRegistering: false,
        });
        this.showDialog(true, "error", err?.response?.data?.message);
      });
  };

  handleSendOtp = async () => {
    const {
      serviceRequired,
      specificRequirement,
      name,
      phoneNumber,
      alternatePhoneNumber,
      houseNumber,
      locality,
      city,
      state,
      country,
      pincode,
      timePreference,
      offerCode,
    } = this.state;
    if (
      !(
        serviceRequired &&
        name &&
        phoneNumber &&
        houseNumber &&
        pincode &&
        timePreference &&
        offerCode &&
        state &&
        city &&
        locality &&
        specificRequirement
      )
    ) {
      this.setState({
        isFormValid: true,
      });

      this.showDialog(true, "error", "Please fill in all required details");
      return;
    }
    try {
      const _data = {
        country_code: "+91",
        mobile_number: this.state.phoneNumber,
      };
      await axios({
        method: "post",
        url: `${BASE_URL}consumerAppAppRoute/sent-otp-by-web`,

        data: _data,
      }).then((res) => this.setState({ verifyOtp: true }));
    } catch (error) {
      console.log(error);
    }
  };

  handleVerifyOtp = async () => {
    try {
      const _data = {
        country_code: "+91",
        mobile_number: this.state.phoneNumber,
        otp: parseInt(this.state.otp),
      };
      await axios({
        method: "post",
        url: `${BASE_URL}consumerAppAppRoute/verify-otp-by-web`,

        data: _data,
      }).then((res) => {
        this.setState({ verifyOtp: false });
        this.handleCheckUserExist();
      });
    } catch (error) {
      // setOtpSend(true);
      alert("Wrong OTP");
    }
  };

  handleCheckUserExist = async () => {
    try {
      let res1 = await axios.post(
        `${BASE_URL}consumerAppAppRoute/register-consumer-by-web`,
        {
          personal_details: {
            phone: {
              country_code: "+91",
              mobile_number: this.state.phoneNumber,
            },
            name: this.state.name,
          },
          address_details_permanent: {
            pincode: this.state.pincode,
          },
        }
      );

      if (res1?.data?.status === 200) {
        this.handleCreateTickect(res1?.data?.data);
      } else {
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  handleInitiatePayment = () => {
    this.setState({ razorpayinitiate: true });
  };

  handleClose = () => {
    this.setState({
      TicketModalOpen: false,
    });
  };

  componentDidMount() {
    this.getAllServicesExists();
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.pincode !== prevState.pincode &&
      this.state.pincode.length === 6
    ) {
      this.fetchAddressDetailsByPincode(this.state.pincode);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
  };

  isValidPhoneNumber = (value) => /^\d{10}$/.test(value || "");

  isValidPincode = (value) => /^\d{6}$/.test(value || "");

  getPincodeFromLocation = () => {
    if (!navigator.geolocation) {
      this.showDialog(
        true,
        "error",
        "Geolocation is not supported by your browser."
      );
      return;
    }

    this.setState({ isFetchingPincode: true });

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const nominatimApiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

        fetch(nominatimApiUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data && data.address) {
              const pincode = data.address.postcode || "";
              this.setState({
                pincode,
                isFetchingPincode: false,
              });

              this.fetchAddressDetailsByPincode(pincode);
            } else {
              this.setState({ isFetchingPincode: false });
              this.showDialog(
                true,
                "error",
                "Pincode not found for your location."
              );
            }
          })
          .catch(() => {
            this.setState({ isFetchingPincode: false });
            this.showDialog(true, "error", "Failed to fetch location data.");
          });
      },
      () => {
        this.setState({ isFetchingPincode: false });
        this.showDialog(
          true,
          "error",
          "Unable to retrieve your location. Please check permissions."
        );
      }
    );
  };

  fetchAddressDetailsByPincode = (pincode) => {
    if (!pincode || pincode.length !== 6) {
      return;
    }

    this.setState({ isFetchingPincode: true });

    fetch(`https://api.postalpincode.in/pincode/${pincode}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0]?.Status === "Success") {
          const postOffice = data[0]?.PostOffice?.[0];
          if (postOffice) {
            this.setState({
              city: postOffice.District || postOffice.Block || "",
              locality: postOffice.Name || "",
              state: postOffice.State || "",
              isFetchingPincode: false,
            });
            return;
          }
        }

        this.setState({ isFetchingPincode: false });
        this.showDialog(
          true,
          "info",
          "Address details not found for this pincode."
        );
      })
      .catch(() => {
        this.setState({ isFetchingPincode: false });
        this.showDialog(true, "error", "Failed to fetch address details.");
      });
  };

  render() {
    const {
      toast: snackBarValues,
      isFormValid,
      serviceRequired,
      specificRequirement,
      name,
      phoneNumber,
      alternatePhoneNumber,
      houseNumber,
      locality,
      pincode,
      city,
      state,
      country,
      timePreference,
      offerCode,
      otp,
    } = this.state;
    const { isMobile } = this.state;
    const bannerImage = isMobile ? MobileBanner : DesktopBanner;
    const phoneValid = this.isValidPhoneNumber(phoneNumber);
    const pincodeValid = this.isValidPincode(pincode);
    return (
      <div className="bg-slate-50 min-h-screen pb-10">
        {this.state.razorpayinitiate === true ? (
          <RazorPayment
            tickectId={this.state.tickectId}
            phonenumber={this.state.phoneNumber}
          />
        ) : null}
        {/* Ticket creation modal code */}

        <Modal
          keepMounted
          open={this.state.TicketModalOpen}
          //   open={false}
          onClose={this.handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%", 
              maxWidth: 700,
              bgcolor: "background.paper",
              border: "2px solid gray",
              boxShadow: 24,
              borderRadius: 4,
              color: "black",
              textAlign: "center",
              p: { xs: 2, md: 4 },
              "& .MuiTypography-root": {
                mb: 2,
              },
              "& .MuiList-root": {
                width: "100%",
              },
              "& .MuiListItem-root": {
                display: "block",
              },
              "& .MuiListItem-root + .MuiDivider-root": {
                margin: "8px 0",
              },
              "@media (max-width: 600px)": {
                width: "100%",
                maxWidth: "100%", 
                borderRadius: 0,
                boxShadow: "none",
              },
            }}
          >
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
              <VerifiedIcon color="success" fontSize="large" />
              Hurray! Your Request has been created
            </Typography>
            <Typography sx={{ mt: 2 }}>
              {/* List content */}
              <List
                sx={{ width: "100%" }}
                component="nav"
                aria-label="mailbox folders"
              >
                <ListItem button>
                  <Typography>
                    Ticket Id: {this.state.ticketModalData?.ticket_id}
                  </Typography>
                </ListItem>
                <Divider />
                <ListItem button divider>
                  <Typography>
                    Ticket Status: {this.state.ticketModalData?.ticket_status}
                  </Typography>
                </ListItem>
                <ListItem button>
                  <Typography>
                    Created At: {this.state.ticketModalData?.createdAt}
                  </Typography>
                </ListItem>
                <Divider />
                <ListItem button>
                  <Typography>
                    Tracking Link:
                    <CopyButton
                      webLink={`https://app.onit.services/#/ServiceStatus/?${this.state.ticketModalData?._id}`}
                    />
                    <Link
                      style={{ marginLeft: "17px" }}
                      to={`ServiceStatus/?${this.state.ticketModalData?._id}`}
                    >
                      Click me
                    </Link>
                  </Typography>
                </ListItem>
              </List>
            </Typography>
          </Box>
        </Modal>

        {snackBarValues.open && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={snackBarValues.open}
            autoHideDuration={snackBarValues.duration}
            onClose={this.closeDialog}
          >
            <Alert
              onClose={this.closeDialog}
              severity={snackBarValues.type}
              sx={{ width: "100%" }}
            >
              {snackBarValues.msg}
            </Alert>
          </Snackbar>
        )}

        <Grid item xs={12} style={stylesCss.headerImageWrapper}>
          <img
            src={bannerImage}
            alt="Responsive Banner"
            style={stylesCss.headerImage}
          />
        </Grid>

        <Card className="mx-auto w-full rounded-lg shadow-md">
          <CardContent className="p-8">
            {/* <div className="mb-6">
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Book a Service
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Fill in the details below to raise your request.
              </Typography>
            </div> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormControl fullWidth>
                <InputLabel id="service-required-label">
                  Service You Required *
                </InputLabel>
                <Select
                  labelId="service-required-label"
                  id="serviceRequired"
                  label="Service You Required *"
                  name="serviceRequired"
                  onChange={this.handleChange}
                  value={serviceRequired}
                  error={isFormValid && !serviceRequired}
                >
                  {this.state.servicesList?.map((ite) => {
                    return (
                      <MenuItem value={ite._id}>
                        <Avatar
                          alt={ite?.service_name}
                          src={ite?.image}
                          sx={{ width: 24, height: 24, marginRight: "10px" }}
                        />
                        {ite.service_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <TextField
                label="Specific Requirement"
                name="specificRequirement"
                value={specificRequirement}
                onChange={this.handleChange}
                error={isFormValid && !specificRequirement}
                required
                multiline
                minRows={2}
                fullWidth
              />

              <TextField
                label="Name (Contact Person)"
                name="name"
                value={name}
                onChange={this.handleChange}
                error={isFormValid && !name}
                required
                fullWidth
              />

              <TextField
                label="Phone Number"
                name="phoneNumber"
                value={phoneNumber}
                onChange={this.handleChange}
                error={isFormValid && (!phoneNumber || !phoneValid)}
                helperText={
                  isFormValid && (!phoneNumber || !phoneValid)
                    ? "Enter a valid 10-digit phone number."
                    : " "
                }
                required
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography>+91</Typography>
                    </InputAdornment>
                  ),
                }}
                inputProps={{ maxLength: 10 }}
              />

              <TextField
                label="Alternate Phone Number"
                name="alternatePhoneNumber"
                value={alternatePhoneNumber}
                onChange={this.handleChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography>+91</Typography>
                    </InputAdornment>
                  ),
                }}
                inputProps={{ maxLength: 10 }}
              />

              <TextField
                label="House Number / Street"
                name="houseNumber"
                value={houseNumber}
                onChange={this.handleChange}
                error={isFormValid && !houseNumber}
                required
                fullWidth
              />

              <TextField
                label="Pincode"
                name="pincode"
                type="number"
                value={pincode}
                onChange={this.handleChange}
                error={isFormValid && (!pincode || !pincodeValid)}
                helperText={
                  isFormValid && (!pincode || !pincodeValid)
                    ? "Enter a valid 6-digit pincode."
                    : " "
                }
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        startIcon={<LocationOnIcon />}
                        onClick={this.getPincodeFromLocation}
                        variant="outlined"
                        size="small"
                        disabled={this.state.isFetchingPincode}
                      >
                        {this.state.isFetchingPincode ? (
                          <CircularProgress size={18} />
                        ) : (
                          "Fetch"
                        )}
                      </Button>
                    </InputAdornment>
                  ),
                }}
                inputProps={{ maxLength: 6 }}
              />

              <TextField
                label="Locality"
                name="locality"
                value={locality}
                onChange={this.handleChange}
                error={isFormValid && !locality}
                required
                fullWidth
              />

              <TextField
                label="City"
                name="city"
                value={city}
                onChange={this.handleChange}
                error={isFormValid && !city}
                required
                fullWidth
              />

              <FormControl fullWidth>
                <InputLabel id="state-label">State *</InputLabel>
                <Select
                  labelId="state-label"
                  id="state"
                  label="State *"
                  name="state"
                  onChange={this.handleChange}
                  value={state}
                  error={isFormValid && !state}
                >
                  {IndianStates?.map((ite) => {
                    return <MenuItem value={ite.value}>{ite.value}</MenuItem>;
                  })}
                </Select>
              </FormControl>

              <TextField
                label="Country"
                name="country"
                value={country}
                onChange={this.handleChange}
                error={isFormValid && !country}
                disabled
                fullWidth
              />

              <FormControl fullWidth>
                <InputLabel id="time-preference-label">
                  Time Preference *
                </InputLabel>
                <Select
                  labelId="time-preference-label"
                  id="timePreference"
                  label="Time Preference *"
                  name="timePreference"
                  onChange={this.handleChange}
                  value={timePreference}
                  error={isFormValid && !timePreference}
                >
                  {AVAILABLE_TIME_PREFERENCES?.map((ite) => {
                    return (
                      <MenuItem value={ite}>
                        {TIME_PREFERENCE_LABELS[ite] || ite}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              {this.state.timePreference == "SPECIFIC_DATE_AND_TIME" ? (
                <div className="md:col-span-2">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      renderInput={(params) => (
                        <TextField {...params} fullWidth />
                      )}
                      label="Select date and time"
                      value={this.state.specific_date_time}
                      onChange={(newValue) => {
                        this.onChangeSpecificDateAndTime(newValue);
                      }}
                      minDate={new Date()}
                      minTime={new Date(0, 0, 0, 8)}
                      maxTime={new Date(0, 0, 0, 20)}
                    />
                  </LocalizationProvider>
                </div>
              ) : (
                ""
              )}

              <TextField
                label="Offer Code"
                name="offerCode"
                value={offerCode}
                onChange={this.handleChange}
                error={isFormValid && !offerCode}
                fullWidth
              />

              {this.state.verifyOtp === true ? (
                <>
                  <TextField
                    label="OTP *"
                    name="otp"
                    value={otp}
                    onChange={this.handleChange}
                    fullWidth
                    InputProps={{
                      className: "bg-blue-50",
                    }}
                  />
                  <div className="md:col-span-2 flex justify-center">
                    <Button
                      variant="contained"
                      onClick={() => this.handleVerifyOtp()}
                      disabled={this.state.isRegistering}
                      size="medium"
                      className="px-10"
                    >
                      VERIFY OTP
                    </Button>
                  </div>
                </>
              ) : (
                <div className="md:col-span-2 flex justify-center">
                  <Button
                    variant="contained"
                    onClick={() => this.handleSendOtp()}
                    disabled={this.state.isRegistering}
                    size="large"
                    className="px-10"
                  >
                    GENERATE OTP
                  </Button>
                </div>
              )}

              {this.state.paymentStatus !== "" && (
                <div className="md:col-span-2 text-center">
                  <Typography>{this.state.paymentStatus}</Typography>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default PublicTicketBooking;
